import { palette } from './palette';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container': {
      background: palette.background.tableHead,
    },
  },
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      // minHeight: `unset !important`,
    },
    '& .hero-shaped__left-side': {
      flex: '0 0 60%',
      maxWidth: '60%',

      '@media(min-width: 900px) and (max-width: 1200px)': {
        flex: '0 0 50%',
        maxWidth: '50%',
      },

      '& .hero-shaped__image': {
        width: '60vw',
        
        '@media(min-width: 900px) and (max-width: 1200px)': {
          width: '50vw',
        }
      },
    },
  },
  /* Login */
  '.logo-image': {
    width: '130px !important',
  },

  '.seva-container': {
    /* Header - styles */
    '& .header-wrapper': {
      background: palette.secondary.contrastText,

      '& .top-bar-logo-container .image': {
        height: '100%'
      },
      '& .menu-item, & .mobile-menu-icon, & .header-phone-link': {
        color: palette.text.highlight,
      },
      '&.active-header': {
        background: palette.text.highlight,
        boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',

        '& .menu-item, & .mobile-menu-icon, & .header-phone-link': {
          color: palette.text.primary,
        },
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.secondary.contrastText,

      '& .hero-section-alternate': {
        paddingBottom: 0,

        '& .section-alternate__content': {
          '@media (min-width: 900px)': {
            padding: '0 48px',
          },

          '& .section-header__cta-item-wrapper': {
            minWidth: '100% !important',
          },

          '& .image-wrapper': {
            paddingBottom: 0,
          },

          '& .image': {
            boxShadow: 'none',
          },
        },
      },
      '& .hero-title, & .hero-subtitle': {
        color: palette.text.highlight,
      },
      '& .hero-subtitle': {
        maxWidth: 550,
      },
      '& .normal-text': {
        fontWeight: 400,
      },
      '& .bold-text': {
        fontWeight: 700,
      },
      '& .sub-text': {
        maxWidth: 500,
        display: 'inline-flex'
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .summary-subtext': {
        color: palette.text.highlight,
        fontSize: 20,
        fontWeight: 700,
      },
      '& .subscription-bg': {
        height: '100%',
        backgroundColor: palette.background.dark,
        color: palette.text.highlight
      },
      '& .section-header__subtitle-wrapper': {
        textAlign: 'center'
      },
      '& .subscription-tabs': {
        '& .MuiTabs-flexContainer': {
          padding: 4
        },
      },
      '& .price-value': {
        color: palette.primary.main
      },
      '& .highlight-card': {
        '& .price-value': {
          color: palette.text.primary
        },
      },
      '& .summary-text': {
        color: palette.text.highlight
      },
      '& .planCard': {
        boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',

        '&:hover': {
          opacity: 0.9,
          background: palette.secondary.main,
          color: palette.secondary.contrastText,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled
        },
        '& .MuiButton-containedSecondary': {
          border: `1px solid ${palette.text.highlight}`,
          background: palette.primary.main,
        }
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      '& .step-counter': {
        width: 60,
        height: 60,
        borderRadius: 8,
        background: palette.background.main,
        color: palette.text.primary,
      },
      '& .image-wrapper, & .image': {
        borderRadius: 24,
        overflow: 'hidden',
      },
    },

    /* Testimonial - Styles*/
    '& .testimonial-wrapper': {
      '& .react-multiple-carousel__arrow': {
        background: '#EE3E38 !important',
        WebkitTapHighlightColor: 'transparent',
      },

      '& .testimonialSection': {
        '& .react-multiple-carousel__arrow--left': {
          left: '25%',
          '@media(max-width: 899px)': {
            left: 0,
          },
        },

        '& .react-multiple-carousel__arrow--right': {
          right: '25%',
          '@media(max-width: 899px)': {
            right: 0,
          },
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-headers': {
        width: '20%',
      },
      '& .savings-column-0, & .savings-column-1': {
        width: '30%',
      },
    },

    /* FAQs */
    '& .faq-wrapper': {
      '& .faq-contact-section .section-header__subtitle-wrapper p': {
        maxWidth: 'unset'
      },
      '& .contact-provider-title': {
        fontWeight: 600
      }
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section': {
      backgroundColor: palette.secondary.main,
    },

    '& .savings-hero-section': {
      height: 303,
      backgroundColor: 'unset',
      background: `url('./images/saving_summary.webp') no-repeat center`,
      backgroundSize: 'cover'
    },

    '& .faq-hero-section': {
      height: 303,
      backgroundColor: 'unset',
      background: `url('./images/faq.webp') no-repeat center`,
      backgroundSize: 'cover'
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      }
    },
  },
};

